import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import formatNumberByLocale from '@utils/format-number-by-locale'
import get from 'lodash/get'
import React, { FC } from 'react'
import EnhancedCell from './EnhancedCell'
import { CentricTypography as Typography } from '@core/component/CentricTypography'

const EnhancedFieldData: FC<CellItem> = ({ rowData, column }) => {
  if (!rowData) {
    return <FieldSkeleton />
  }
  return (
    <EnhancedCell>
      <Typography variant='h6'>
        {formatNumberByLocale(get(rowData, column?.enhancedField)) || 0}
      </Typography>
    </EnhancedCell>
  )
}

export default EnhancedFieldData
